//client/src/hooks/useFaqs.js
import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export const useFaqs = () => {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchFaqs = useCallback(async () => {
        try {
            setLoading(true);
            const response = await api.get('/admin/institucional/faqs');
            setFaqs(response.data.data);
        } catch (err) {
            setError(err.response?.data?.error || err.response?.data?.message || 'Erro ao buscar FAQs');
        } finally {
            setLoading(false);
        }
    }, []);

    // ✅ FUNÇÃO ADICIONADA: Para buscar um único FAQ por ID.
    const getFaq = useCallback(async (id) => {
        try {
            // Não ativa o loading global para não piscar a tela
            const response = await api.get(`/admin/institucional/faqs/${id}`);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || err.response?.data?.message || 'Erro ao buscar a FAQ');
        }
    }, []);

    const createFaq = useCallback(async (faqData) => {
        try {
            const response = await api.post('/admin/institucional/faqs', faqData);
            setFaqs(prev => [...prev, response.data.data]);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || err.response?.data?.message || 'Erro ao criar FAQ');
        }
    }, []);

    const updateFaq = useCallback(async (id, faqData) => {
        try {
            const response = await api.put(`/admin/institucional/faqs/${id}`, faqData);
            setFaqs(prev => prev.map(faq => faq._id === id ? response.data.data : faq));
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || err.response?.data?.message || 'Erro ao atualizar FAQ');
        }
    }, []);

    const deleteFaq = useCallback(async (id) => {
        try {
            await api.delete(`/admin/institucional/faqs/${id}`);
            setFaqs(prev => prev.filter(faq => faq._id !== id));
        } catch (err) {
            throw new Error(err.response?.data?.error || err.response?.data?.message || 'Erro ao deletar FAQ');
        }
    }, []);
    
    // As funções abaixo foram mantidas do seu código original
    const updateFaqsOrder = useCallback(async (faqsOrder) => {
        try {
            const response = await api.put('/admin/institucional/faqs/update-order', { faqs: faqsOrder });
            setFaqs(faqsOrder);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || err.response?.data?.message || 'Erro ao atualizar ordem das FAQs');
        }
    }, []);

    const markFaqHelpful = useCallback(async (id, helpful) => {
        try {
            const response = await api.put(`/institucional/faqs/${id}/helpful`, { helpful });
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || err.response?.data?.message || 'Erro ao marcar FAQ');
        }
    }, []);

    const getFaqsByCategory = useCallback(async (category) => {
        try {
            const response = await api.get(`/admin/institucional/faqs/category/${category}`);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.error || err.response?.data?.message || 'Erro ao buscar FAQs por categoria');
        }
    }, []);

    useEffect(() => {
        fetchFaqs();
    }, [fetchFaqs]);

    return {
        faqs,
        loading,
        error,
        getFaq, // ✅ Exportar a nova função
        createFaq,
        updateFaq,
        deleteFaq,
        updateFaqsOrder,
        markFaqHelpful,
        getFaqsByCategory,
        refetch: fetchFaqs
    };
};